import { Component, createSignal, For, Show } from 'solid-js'
import { i18nStore } from '../../store'
import { MessageSquare, Heart, Share2 } from 'lucide-solid'

const TrendsPage: Component = () => {
  const i18n = i18nStore((s) => ({ t: s.t }))
  const [activeTab, setActiveTab] = createSignal('latest')

  // Mock data for trends
  const mockTrends = [
    { id: 1, user: 'UserA', char: 'CharacterX', content: 'This was such an amazing conversation fragment...', likes: 124, comments: 12, time: '2h ago' },
    { id: 2, user: 'UserB', char: 'CharacterY', content: 'I can\'t believe how realistic the response was!', likes: 89, comments: 5, time: '5h ago' },
  ]

  return (
    <div class="flex flex-col gap-4 p-4">
      <h1 class="text-2xl font-bold">{i18n.t.trends_title}</h1>
      
      <div class="flex gap-6 border-b border-[var(--bg-700)] pb-2">
        <button 
          onClick={() => setActiveTab('latest')}
          class="relative pb-2 text-sm font-medium transition-colors"
          classList={{ 'text-[var(--hl-500)]': activeTab() === 'latest', 'text-[var(--bg-400)]': activeTab() !== 'latest' }}
        >
          {i18n.t.trends_latest}
          <Show when={activeTab() === 'latest'}>
            <div class="absolute bottom-0 left-0 h-0.5 w-full bg-[var(--hl-500)]" />
          </Show>
        </button>
        <button 
          onClick={() => setActiveTab('follow')}
          class="relative pb-2 text-sm font-medium transition-colors"
          classList={{ 'text-[var(--hl-500)]': activeTab() === 'follow', 'text-[var(--bg-400)]': activeTab() !== 'follow' }}
        >
          {i18n.t.trends_follow}
          <Show when={activeTab() === 'follow'}>
            <div class="absolute bottom-0 left-0 h-0.5 w-full bg-[var(--hl-500)]" />
          </Show>
        </button>
      </div>

      <div class="flex flex-col gap-4">
        <For each={mockTrends}>
          {(item) => (
            <div class="flex flex-col gap-3 rounded-xl bg-[var(--bg-800)] p-4 border border-[var(--bg-700)]">
              <div class="flex items-center justify-between">
                <div class="flex items-center gap-2">
                  <div class="h-8 w-8 rounded-full bg-[var(--bg-700)]" />
                  <span class="text-sm font-bold">{item.user}</span>
                  <span class="text-xs text-[var(--bg-400)]">shared with</span>
                  <span class="text-sm font-bold text-[var(--hl-500)]">{item.char}</span>
                </div>
                <span class="text-xs text-[var(--bg-400)]">{item.time}</span>
              </div>
              <p class="text-sm text-[var(--bg-100)]">{item.content}</p>
              <div class="flex items-center gap-6 pt-2 border-t border-[var(--bg-700)]">
                <button class="flex items-center gap-1 text-xs text-[var(--bg-400)] hover:text-[var(--hl-500)]">
                  <Heart size={16} /> {item.likes}
                </button>
                <button class="flex items-center gap-1 text-xs text-[var(--bg-400)] hover:text-[var(--hl-500)]">
                  <MessageSquare size={16} /> {item.comments}
                </button>
                <button class="flex items-center gap-1 text-xs text-[var(--bg-400)] hover:text-[var(--hl-500)]">
                  <Share2 size={16} />
                </button>
              </div>
            </div>
          )}
        </For>
      </div>
    </div>
  )
}

export default TrendsPage



